import { createCommand, LexicalCommand } from 'lexical'

import { InsertAttachmentPayload } from './interface'

export const UPLOAD_ATTACHMENT_COMMAND: LexicalCommand<unknown> = createCommand(
  'UPLOAD_ATTACHMENT_COMMAND'
)

export const INSERT_ATTACHMENT_COMMAND: LexicalCommand<InsertAttachmentPayload> =
  createCommand('INSERT_ATTACHMENT_COMMAND')
